import React from 'react';
import { observer } from 'mobx-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import styles from './dashboard.module.css';
import { GRID_COLUMNS, WidgetLayout } from '../../models/bridge.model';
import { bridgeWidgets } from './widgets/bridge_widgets';
import bridgeLayoutStore from '../../stores/bridge_layout.store';

interface Props {
  layout: WidgetLayout;
  editing: boolean;
}

const BridgeWidgetCard = observer(({ layout, editing }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: layout.id, disabled: !editing });
  const { title, minSpan, component: Widget } = bridgeWidgets[layout.id];

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    '--span': layout.span
  } as React.CSSProperties;

  return (
    <div ref={setNodeRef} style={style}
      className={`${styles.card} ${isDragging && styles.cardDragging} ` +
        `${editing && !layout.visible && styles.cardHidden}`}>
      {editing &&
        <div className={styles.cardToolbar}>
          <div className={styles.dragHandle} {...attributes} {...listeners}>⠿ {title}</div>
          <button className={styles.toolbarButton} disabled={layout.span <= minSpan}
            onClick={() => bridgeLayoutStore.setSpan(layout.id, layout.span - 1)}>−</button>
          <div className={styles.spanLabel}>{layout.span}/{GRID_COLUMNS}</div>
          <button className={styles.toolbarButton} disabled={layout.span >= GRID_COLUMNS}
            onClick={() => bridgeLayoutStore.setSpan(layout.id, layout.span + 1)}>+</button>
          <button className={styles.toolbarButton} onClick={() => bridgeLayoutStore.toggleVisible(layout.id)}>
            {layout.visible ? 'Hide' : 'Show'}
          </button>
        </div>
      }
      <Widget span={layout.span} />
    </div>
  );
});

export default BridgeWidgetCard;
